import { useNavigate } from "react-router-dom";
import "./ClientsField.css";

export default function ClientsField({ data }) {
  const navigate = useNavigate();

  return (
    <div className="clientFieldWrapper">
      {data?.length === 0 ? (
        <h1 className="emptyHeader">Нет клиентов, ожидающих регистрации</h1>
      ) : (
        data?.map((item, i) => {
          return (
            <div
              className="clientFieldCard"
              key={i}
              onClick={() =>
                navigate("/clientInfo", { state: { clients: item } })
              }
            >
              <div className="clientFieldInfo">
                <span className="clientFieldCompany">{item?.counterparty}</span>
                <span className="clientFieldReceiver">{item?.recipient}</span>
                <span className="clientFieldAddress">
                  {item?.deliveryPlace}
                </span>
              </div>
              <div className="clientFieldContact">
                <span className="clientFieldName">{item?.FIO}</span>
                <span className="clientFieldPhone">{item?.number}</span>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
